import styled from '@emotion/styled';
import { lpPageColors, mainColors } from 'src/assets/colors';

export const TableHead = styled('div', { label: 'TableHead' })`
   margin: 2px 0 6px 0;
`;

export const TableHeadCell = styled('div', { label: 'TableHeadCell' })`
    flex: 1 1 0%;
    font-size: 10px;
    line-height: 1.2;
    color: ${mainColors.main.primary};
    font-weight: bold;
    padding: 6px 8px;
    border-right: 1px solid white;

    &:last-of-type {
        border-right: 0;
    }
`;

export const TableBody = styled('div', { label: 'TableBody' })`

`;


export const TableRow = styled('div', { label: 'TableRow' })`
    display: flex;
    border: 0;
    margin: 3px 0;
    background-color: ${lpPageColors.paleGrey};
    padding: 3px 0;
    font-size: 12px;
    color: ${mainColors.main.primary};

    &:nth-of-type(even) {
        background-color: transparent;
    }
`;

export const TableHeadRow = styled(TableRow, { label: 'TableHeadRow' })`
    padding: 0;
`;

export const TableCell = styled('div', { label: 'TableCell' })`
    flex: 1 1 0%;
    border-right: 1px solid white;
    padding: 6px 8px;
    text-transform: capitalize;

    &:last-of-type {
        border-right: 0;
    }
`;
